export default __webpack_public_path__ + "static/media/backgroundImage.b7bf13d5.webp";